import React, { memo } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import { googleLogin } from "../services/authService";

function SocialLoginButtons() {
  const handleGoogleLoginSuccess = async (credentialResponse) => {
    const idToken = credentialResponse.credential;

    try {
      const data = await googleLogin(idToken);
      if (data && data.token) {
        toast.success("Google login successful!");
        window.location.href = "/explore";
      }
    } catch (err) {
      toast.error(err.message || "Google login failed");
    }
  };

  const handleGoogleLoginFailure = () => {
    toast.error("Google login failed");
  };

  return (
    <div className="social-login" style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
      <GoogleLogin
        onSuccess={handleGoogleLoginSuccess}
        onError={handleGoogleLoginFailure}
      />
    </div>
  );
}

export default memo(SocialLoginButtons);